import { DmsTypeOptions } from "@dms/configs/constants";
import type { MessageId } from "@domain/intl/useTranslation";
import type { IDocumentType } from "@domain/models/dms";

import type { AgentDmsFolder } from "./runner/types";

/** The DMS folder name as the DMS shows it: translated type plus the subfolder's own name. */
export const resolveDmsFolder = (
    documentTypes: IDocumentType[] | undefined,
    type: string,
    subType: string | null | undefined,
): AgentDmsFolder => {
    // DmsTypeOptions keys are app.titles.* message ids typed as string
    const labelId = DmsTypeOptions.find((option) => option.value === type)?.translationKey as MessageId | undefined;
    const subName = subType
        ? documentTypes?.find((t) => t.id === type)?.subTypes?.find((s) => s.id === subType)?.name
        : undefined;
    return { type, ...(labelId ? { labelId } : {}), ...(subName ? { subName } : {}) };
};
